import { Directive, TemplateRef, AfterViewInit, inject } from '@angular/core';
import { ZefErrorTemplateService } from '../../error-template.service';

@Directive({
  selector: '[zefSnackErrorOutlet]',
  standalone: false
})
export class SnackErrorOutletDirective implements AfterViewInit {

  templateRef = inject(TemplateRef<any>);
  #errorTemplate = inject(ZefErrorTemplateService);

  ngAfterViewInit() {
    this.#errorTemplate.setTemplate(
      this.templateRef,
      'snack'
    );
  }
}
